<script>
export default {
  name: 'no-image-file.app',
  props: {
    width: {
      type: String,
      default: '125px'
    },
    height: {
      type: String,
      default: '125px'
    }
  }
}
</script>
<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center  bg-soft-light"
    :style="{
      height,
      width,
      color: '#CECECE'
    }"
  >
    <i class="far fa-image font-size-18" />
    <small class="my-2">No Image</small>
  </div>
</template>
